<template>
	<div id="fitco">
		<loading></loading>
		<router-view></router-view>
		<annotation></annotation>
	</div>
</template>

<script>
import annotation from "@/components/annotation.vue";
import loading from "@/components/loading.vue";

export default {
	components: { annotation, loading },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap");

*:not(i) {
	font-family: "Open Sans", sans-serif;
}

body {
	-webkit-font-smoothing: antialiased;
}

::-webkit-scrollbar {
	width: 0;
}

.columns.is-vcentered {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}

.button.thick {
	border-width: 3px !important;
}

/* BULMA CARD STYLING */
.card {
	box-shadow: 0 4px 12px -2px rgba(#6b75a1, 0.16);
	border-radius: 0.75rem;
}

.equal-height {
	display: flex;
	flex-direction: column;
	height: 100%;
}

.equal-height .card-content {
	flex: auto;
}

.card-1 {
	background-image: url("~@/assets/card/card-1.jpg");
	background-repeat: no-repeat;
	background-size: cover;
}

.card-2 {
	background-image: url("~@/assets/card/card-3.jpg");
	background-repeat: no-repeat;
	background-size: cover;
}

.card-3 {
	background-image: url("~@/assets/card/card-2.jpg");
	background-repeat: no-repeat;
	background-size: cover;
}

/* TEXT STYLING */
.is-title {
	font-family: "Montserrat", sans-serif !important;
	font-weight: 600;
	line-height: 1.125;
}
.is-subtitle {
	line-height: 1.25;
	margin-bottom: 1.5rem;
}

.button.is-wide {
	padding-left: 24px !important;
	padding-right: 24px !important;
}

/* DESKTOP SIZE ONLY */
@media screen and (min-width: 1024px) and (max-width: 1215px) {
	.image.large {
		max-width: 60%;
	}
}

/* MOBILE SIZE ONLY */
@media screen and (max-width: 768px) {
	.is-title {
		font-size: 2rem;
	}
	.is-subtitle {
		font-size: 1.25rem;
	}

	.hero.is-fullheight.fitco {
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	/* BACKGROUND */
	.hero.is-fullheight.fitco.landing {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/landing-mobile.jpg");
	}
	.hero.is-fullheight.fitco.lecture {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/lecture-mobile.jpg");
	}
	.hero.is-fullheight.fitco.standing {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/stand-mobile.jpg");
	}
	.hero.hero.is-fullheight.fitco.group {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/group-mobile.jpg");
	}
	.hero.is-fullheight.fitco.meet {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/meet-mobile.jpg");
	}
	.hero.is-fullheight.fitco.contact {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/contact-mobile.jpg");
	}
}

/* TABLET SIZE AND UP */
@media screen and (min-width: 769px) {
	.is-title {
		font-size: 3rem;
	}
	.is-subtitle {
		font-size: 2rem;
	}

	/* FULLHEIGHT HERO BACKGROUND */
	.hero.is-fullheight.fitco {
		background-size: cover;
		background-repeat: no-repeat;
		background-attachment: fixed;
	}

	/* BACKGROUND */
	.hero.is-fullheight.fitco.landing {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/landing-desktop.jpg");
	}
	.hero.is-fullheight.fitco.lecture {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/lecture-desktop.jpg");
	}
	.hero.is-fullheight.fitco.standing {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/stand-desktop.jpg");
	}
	.hero.is-fullheight.fitco.group {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/group-desktop.jpg");
	}
	.hero.is-fullheight.fitco.meet {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/meet-desktop.jpg");
	}
	.hero.is-fullheight.fitco.contact {
		background-image: url("https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/contact-desktop.jpg");
	}
}

/* ANIMATION */

@keyframes wave-animation {
	0% {
		transform: rotate(0deg);
	}
	10% {
		transform: rotate(14deg);
	} /* The following five values can be played with to make the waving more or less extreme */
	20% {
		transform: rotate(-8deg);
	}
	30% {
		transform: rotate(14deg);
	}
	40% {
		transform: rotate(-4deg);
	}
	50% {
		transform: rotate(10deg);
	}
	60% {
		transform: rotate(0deg);
	} /* Reset for the last half to pause */
	100% {
		transform: rotate(0deg);
	}
}

@keyframes bounce {
	50% {
		transform: translateY(-50%);
	}
}
</style>



<style>
.input {
	box-shadow: none !important;
}

.down::before {
	animation: bounce 2s ease infinite;
	bottom: 2rem;
	color: #99e3ca;
	content: "╲╱";
	font-size: 1rem;
	height: 4rem;
	left: 50%;
	letter-spacing: -1px;
	line-height: 4rem;
	margin-left: -3rem;
	opacity: 0.8;
	position: absolute;
	text-align: center;
	width: 6rem;
}

.wave {
	animation-name: wave-animation; /* Refers to the name of your @keyframes element below */
	animation-duration: 5s; /* Change to speed up or slow down */
	animation-iteration-count: infinite; /* Never stop waving :) */
	transform-origin: 70% 70%; /* Pivot around the bottom-left palm */
	display: inline-block;
	padding-left: 8px;
}

.fitco-underline {
	text-decoration: underline;
	text-decoration-color: #99e3ca;
}

.is-fitco {
	background-size: cover;
	background-repeat: no-repeat;
	background-attachment: fixed;
}

/* WIDESCREEN SIZE */
@media screen and (min-width: 1216px) {
	.image.large {
		max-width: 40%;
	}
	.fitco-card {
		min-height: 400px;
	}
}

/* DESKTOP SIZE */
@media screen and (min-width: 1024px) and (max-width: 1215px) {
	.image.large {
		max-width: 50%;
	}
}

/* TABLET SIZE */
@media screen and (min-width: 769px) and (max-width: 1023px) {
}

/* TABLET SIZE AND UP */
@media screen and (min-width: 769px) {
	.title-fitco {
		font-size: 3rem;
	}
}
</style>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #99e3ca;
$primary-invert: findColorInvert($primary);

$white: #f2f0f1;
$white-invert: findColorInvert($white);

$dark: #070a0a;
$dark-invert: findColorInvert($dark);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
	"white": (
		$white,
		$white-invert,
	),
	"black": (
		$black,
		$white,
	),
	"light": (
		$light,
		$light-invert,
	),
	"dark": (
		$dark,
		$dark-invert,
	),
	"primary": (
		$primary,
		$primary-invert,
	),
	"info": (
		$info,
		$info-invert,
	),
	"success": (
		$success,
		$success-invert,
	),
	"warning": (
		$warning,
		$warning-invert,
	),
	"danger": (
		$danger,
		$danger-invert,
	),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$footer-background-color: #070a0a;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>